import { styled } from '@mui/system';
import { Box, Button } from '@mui/material';
import { ArrowForwardIosOutlined } from '@mui/icons-material';
import { PaidOutlined, NotificationsOutlined, CalendarMonthOutlined } from '@mui/icons-material';
import { StyledAvatar } from '../../StyledAvatar/StyledAvatar';

export const UserInfoContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const ActionMenusContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  width: '100%',
  paddingTop: '1rem',
}));

export const ActionMenuContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  borderRadius: '12px',
  display: 'flex',
  padding: 0,
  margin: 0,
  flexDirection: 'column',
  cursor: 'pointer',
  width: '100%',
  listStyle: 'none',
  minWidth: 'fit-content',
  overflow: 'hidden', // This ensures child hover effects respect the border radius
}));

export const ActionMenuOptionContainer = styled('button')(({ condensed = false, isLast = false, theme }) => ({
  padding: 0,
  display: 'flex',
  border: 'none',
  color: 'white',
  paddingLeft: theme.spacing(2),
  textAlign: 'left',
  background: 'transparent',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: theme.spacing(1),
  cursor: 'pointer',
  width: '100%',
  height: condensed ? '3.25rem' : '3.75rem',
  borderBottom: isLast ? 'none' : `1px solid ${theme.palette.divider}`,
  paddingRight: theme.spacing(2), // Matches paddingLeft of ActionMenuContainer container without cutting off buttom border
  transition: 'background-color 0.2s ease, transform 0.2s ease',
  '&[disabled]': {
    opacity: .5,
    cursor: 'not-allowed',
  },
  '&:hover': {
    backgroundColor: theme.palette.background.secondaryHover,
  },
  // Set hover border radius for first and last items
  '&:first-of-type': {
    borderTopLeftRadius: theme.spacing(1.5),
    borderTopRightRadius: theme.spacing(1.5),
  },
  '&:last-of-type': {
    borderBottomLeftRadius: theme.spacing(1.5),
    borderBottomRightRadius: theme.spacing(1.5),
  },
}));

export const IconAndTextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  '& > :first-child': {
    // Set avatars to a fixed width to ensure text is aligned properly
    flex: '0 0 24px',
  },
  '& > :last-child': {
    flex: '1 1 auto',
  },
}));

export const FlexColumn = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const ButtonContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '.5rem',
  width: '100%',
  padding: '1rem 0',
}));

export const StyledButton = styled(Button)(() => ({
  width: '100%',
  height: '3.125rem',
}));

export const StyledIconForward = styled(ArrowForwardIosOutlined)(({ theme }) => ({
  color: theme.colors.gray,
  fontSize: '1rem',
}));

export const StyledIconPaid = styled(PaidOutlined)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const StyledIconNotifications = styled(NotificationsOutlined)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const StyledIconCalendar = styled(CalendarMonthOutlined)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const AvatarContainer = styled('div')(() => ({
  position: 'relative',
  width: 120,
  height: 120,
  '&:hover': {
    '& .edit-icon': {
      opacity: 1,
    },
    '& .avatar': {
      filter: 'brightness(0.5)',
      cursor: 'pointer',
    },
  },
}));

export const CustomizableAvatar = styled(StyledAvatar)(() => ({
  width: '100%',
  height: '100%',
  transition: 'filter 0.3s ease',
}));

export const EditIconOverlay = styled('div')(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  opacity: 0,
  transition: 'opacity 0.3s ease',
  pointerEvents: 'none',
  '& > svg': {
    width: 32,
    height: 32,
  },
}));
